import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Register from './views/Register.vue';
import GetToken from './views/GetToken.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import ResetPassword from './views/ResetPassword.vue';
import ChangePassword from './views/ChangePassword.vue';
import store from './store'

Vue.use(Router);

function guardMyroute(to, from, next) {
  if (store.state.auth.status.loggedIn && store.state.auth.user.approved) {
    next(); // allow to enter route
  } else if (store.state.auth.status.loggedIn && !store.state.auth.user.approved) {
    next('/')
  }
  else {
    next('/login'); // go to '/login';
  }
}

function guardAdmin(to, from, next) {
  if (store.state.auth.status.loggedIn && store.state.auth.user.approved && store.state.auth.user.username === "admin@localhost.com") {
    next(); // allow to enter route
  } else if (store.state.auth.status.loggedIn && store.state.auth.user.approved && store.state.auth.user.username !== "admin@localhost.com") {
    next('/dashboard' + currentRole())
  }
  else {
    next('/login'); // go to '/login';
  }
}

function guardTutorial(to, from, next) {
  if (store.state.auth.status.loggedIn) {
    next()
  } else {
    next('/login')
  }
}

function checkForUser(to, from, next) {
  console.log("ROUTER", store.state.auth)
  if (store.state.auth.status.loggedIn && store.state.auth.user.approved) {
    next('/dashboard' + currentRole())
  }
  else {
    next();
  }
}

function currentRole() {
  console.log("HEEEYYY", store.state.auth.user)
  console.log("BLOCCCCCCKKKKKK", store)
  switch (store.state.auth.user.roles[0].name) {
    case "ROLE_ADMIN":
      return "Admin";

      break;

    case "ROLE_TSO":
      return "TSO";

      break;
    case "ROLE_DSO":
      return "DSO";

      break;
    case "ROLE_FSP":
      return "FSP";

      break;
    default:
      return "DSO";
  }
}

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      component: Home
    },
    {
      path: '/login',
      beforeEnter: checkForUser,
      component: Login
    },
    {
      path: '/register',
      beforeEnter: checkForUser,
      component: Register
    },
    {
      path: '/getToken',
      component: GetToken
    },
    {
      path: '/forgotPassword',
      component: ForgotPassword
    },
    {
      path: '/resetPassword',
      component: ResetPassword
    },
    {
      path: '/changePassword',
      component: ChangePassword
    },
    {
      path: '/profileAdmin',
      beforeEnter: guardMyroute,
      name: 'profileAdmin',
      // lazy-loaded
      component: () => import('./views/ProfileAdmin.vue')
    },
    {
      path: '/profileTSO',
      beforeEnter: guardMyroute,
      name: 'profileTSO',
      // lazy-loaded
      component: () => import('./views/ProfileTSO.vue')
    },
    {
      path: '/profileDSO',
      beforeEnter: guardMyroute,
      name: 'profileDSO',
      // lazy-loaded
      component: () => import('./views/ProfileDSO.vue')
    },
    {
      path: '/profileFSP',
      beforeEnter: guardMyroute,
      name: 'profileFSP',
      // lazy-loaded
      component: () => import('./views/ProfileFSP.vue')
    },
    {
      path: '/mod',
      beforeEnter: guardMyroute,
      name: 'moderator',
      // lazy-loaded
      component: () => import('./views/BoardModerator.vue')
    },
    {
      path: '/user',
      beforeEnter: guardMyroute,
      name: 'user',
      // lazy-loaded
      component: () => import('./views/BoardUser.vue')
    },

    {
      path: '/tso',
      beforeEnter: guardMyroute,
      name: 'tso',
      // lazy-loaded
      component: () => import('./views/BoardTSO.vue')
    },
    {
      path: '/dso',
      beforeEnter: guardMyroute,
      name: 'dso',
      // lazy-loaded
      component: () => import('./views/BoardDSO.vue')
    },
    {
      path: '/fsp',
      beforeEnter: guardMyroute,
      name: 'fsp',
      // lazy-loaded
      component: () => import('./views/BoardFSP.vue')
    },

    /* {
      path: "/",
      name: "landing",
      component: () => import("./pages/Landing")
    }, */

    {
      path: "/dashboard",
      name: "dashboard",
      beforeEnter: guardMyroute,
      component: () => import("./pages/Dashboard")
    },

    {
      path: "/dashboardAdmin",
      name: "dashboardAdmin",
      beforeEnter: guardMyroute,
      component: () => import("./pages/DashboardAdmin")
    },

    {
      path: "/dashboardTSO",
      name: "dashboardTSO",
      beforeEnter: guardMyroute,
      component: () => import("./pages/DashboardTSO")
    },

    {
      path: "/dashboardDSO",
      name: "dashboardDSO",
      beforeEnter: guardMyroute,
      component: () => import("./pages/DashboardDSO")
    },

    {
      path: "/dashboardFSP",
      name: "dashboardFSP",
      beforeEnter: guardMyroute,
      component: () => import("./pages/DashboardFSP")
    },

    /* {
      path: "/signin",
      name: "signin",
      component: () => import("./pages/Signin")
    },
    {
      path: "/register",
      name: "register",
      component: () => import("./pages/Register")
    }, */

    {
      path: "/consumption",
      name: "consumption",
      beforeEnter: guardMyroute,
      component: () => import("./pages/Consumption")
    },

    {
      path: "/buypart1",
      name: "buypart1",
      beforeEnter: guardMyroute,
      component: () => import("./pages/BuyPart1")
    },

    {
      path: "/buypart1Admin",
      name: "buypart1Admin",
      beforeEnter: guardMyroute,
      component: () => import("./pages/BuyPart1Admin")
    },

    {
      path: "/summaryAdmin",
      name: "summaryAdmin",
      beforeEnter: guardMyroute,
      component: () => import("./pages/SummaryAdmin")
    },
    {
      path: "/summaryTSO",
      name: "summaryTSO",
      beforeEnter: guardMyroute,
      component: () => import("./pages/SummaryTSO")
    },
    {
      path: "/summaryDSO",
      name: "summaryDSO",
      beforeEnter: guardMyroute,
      component: () => import("./pages/SummaryDSO")
    },
    {
      path: "/summaryFSP",
      name: "summaryFSP",
      beforeEnter: guardMyroute,
      component: () => import("./pages/SummaryFSP")
    },

    {
      path: "/consumptionAdmin",
      name: "consumptionAdmin",
      beforeEnter: guardMyroute,
      component: () => import("./pages/ConsumptionAdmin")
    },

    {
      path: "/buypart1Admin",
      name: "buypart1Admin",
      beforeEnter: guardMyroute,
      component: () => import("./pages/BuyPart1Admin")
    },

    {
      path: "/summaryAdmin",
      name: "summaryAdmin",
      beforeEnter: guardMyroute,
      component: () => import("./pages/SummaryAdmin")
    },

    {
      path: "/network/networkAdminBG",
      alias: "/networkAdminBG",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkAdminBG")
    },

    {
      path: "/network/networkTsoBG",
      alias: "/networkTsoBG",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkTsoBG")
    },

    {
      path: "/network/networkDsoBG",
      alias: "/networkDsoBG",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkDsoBG")
    },

    {
      path: "/network/networkAdminRO",
      alias: "/networkAdminRO",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkAdminRO")
    },

    {
      path: "/network/networkTsoRO",
      alias: "/networkTsoRO",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkTsoRO")
    },

    {
      path: "/network/networkDsoRO",
      alias: "/networkDsoRO",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkDsoRO")
    },

    {
      path: "/network/networkAdminSI",
      alias: "/networkAdminSI",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkAdminSI")
    },

    {
      path: "/network/networkTsoSI",
      alias: "/networkTsoSI",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkTsoSI")
    },

    {
      path: "/network/networkDsoSI",
      alias: "/networkDsoSI",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkDsoSI")
    },

    {
      path: "/network/networkAdminCH",
      alias: "/networkAdminCH",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkAdminCH")
    },

    {
      path: "/network/networkTsoCH",
      alias: "/networkTsoCH",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkTsoCH")
    },

    {
      path: "/network/networkDsoCH",
      alias: "/networkDsoCH",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkDsoCH")
    },

    {
      path: "/network/networkAdminTR",
      alias: "/networkAdminTR",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkAdminTR")
    },

    {
      path: "/network/networkTsoTR",
      alias: "/networkTsoTR",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkTsoTR")
    },

    {
      path: "/network/networkDsoTR",
      alias: "/networkDsoTR",
      beforeEnter: guardMyroute,
      name: "network",
      component: () => import("./pages/Network/NetworkDsoTR")
    },

    {
      path: "/devices",
      alias: "/devices",
      beforeEnter: guardMyroute,
      name: "devices",
      component: () => import("./pages/Devices")
    },
    {
      path: "/asset/assets",
      alias: "/assets",
      beforeEnter: guardMyroute,
      name: "assets",
      component: () => import("./pages/Assets/AssetsList")
    },

    {
      path: "/asset/assetsDSO",
      alias: "/assetsDSO",
      beforeEnter: guardMyroute,
      name: "assetsDSO",
      component: () => import("./pages/Assets/AssetsListDSO")
    },

    {
      path: "/asset/assetsTSO",
      alias: "/assetsTSO",
      beforeEnter: guardMyroute,
      name: "assetsTSO",
      component: () => import("./pages/Assets/AssetsListTSO")
    },

    {
      path: "/asset/assetsAdmin",
      alias: "/assetsAdmin",
      beforeEnter: guardMyroute,
      name: "assetsAdmin",
      component: () => import("./pages/Assets/AssetsListAdmin")
    },

    {
      path: "/asset/uploadAssets",
      alias: "/uploadAssets",
      beforeEnter: guardMyroute,
      name: "uploadAssets",
      component: () => import("./pages/Assets/UploadAssets")
    },

    {
      path: "/asset/uploadAssetsAdmin",
      alias: "/uploadAssetsAdmin",
      beforeEnter: guardMyroute,
      name: "uploadAssetsAdmin",
      component: () => import("./pages/Assets/UploadAssetsAdmin")
    },

    {
      path: "/asset/assets/:id",
      beforeEnter: guardMyroute,
      name: "asset-details",
      component: () => import("./pages/Assets/Asset")
    },

    {
      path: "/asset/assetsAdmin/:id",
      beforeEnter: guardMyroute,
      name: "asset-details",
      component: () => import("./pages/Assets/AssetAdmin")
    },

    {
      path: "/asset/addAsset",
      beforeEnter: guardMyroute,
      name: "addAsset",
      component: () => import("./pages/Assets/AddAsset")
    },

    {
      path: "/asset/addAssetAdmin",
      beforeEnter: guardMyroute,
      name: "addAssetAdmin",
      component: () => import("./pages/Assets/AddAssetAdmin")
    },

    {
      path: "/offer/offers",
      beforeEnter: guardMyroute,
      alias: "/offers",
      name: "offers",
      component: () => import("./pages/Offers/OffersList")
    },

    {
      path: "/offer/offersDSO",
      beforeEnter: guardMyroute,
      alias: "/offersDSO",
      name: "offersDSO",
      component: () => import("./pages/Offers/OffersListDSO")
    },

    {
      path: "/offer/offersTSO",
      beforeEnter: guardMyroute,
      alias: "/offersTSO",
      name: "offersTSO",
      component: () => import("./pages/Offers/OffersListTSO")
    },

    {
      path: "/offer/offersAdmin",
      beforeEnter: guardMyroute,
      alias: "/offersAdmin",
      name: "offersAdmin",
      component: () => import("./pages/Offers/OffersListAdmin")
    },

    {
      path: "/offer/offersAdmin/:id",
      beforeEnter: guardMyroute,
      name: "offer-details",
      component: () => import("./pages/Offers/OfferAdmin")
    },

    {
      path: "/offer/uploadOffers",
      alias: "/uploadOffers",
      beforeEnter: guardMyroute,
      name: "uploadOffers",
      component: () => import("./pages/Offers/UploadOffers")
    },

    {
      path: "/offer/uploadOffersAdmin",
      alias: "/uploadOffersAdmin",
      beforeEnter: guardMyroute,
      name: "uploadOffersAdmin",
      component: () => import("./pages/Offers/UploadOffersAdmin")
    },

    {
      path: "/offer/offers/:id",
      beforeEnter: guardMyroute,
      name: "offer-details",
      component: () => import("./pages/Offers/Offer")
    },

    {
      path: "/offer/addOffer",
      beforeEnter: guardMyroute,
      name: "addOffer",
      component: () => import("./pages/Offers/AddOffer")
    },

    {
      path: "/offer/addOfferAdmin",
      beforeEnter: guardMyroute,
      name: "addOfferAdmin",
      component: () => import("./pages/Offers/AddOfferAdmin")
    },

    {
      path: "/request/requests",
      beforeEnter: guardMyroute,
      alias: "/requests",
      name: "requests",
      component: () => import("./pages/Requests/RequestsList")
    },

    {
      path: "/request/requestsFSP",
      beforeEnter: guardMyroute,
      alias: "/requestsFSP",
      name: "requestsFSP",
      component: () => import("./pages/Requests/RequestsListFSP")
    },

    {
      path: "/request/requestsAdmin",
      beforeEnter: guardMyroute,
      alias: "/requestsAdmin",
      name: "requestsAdmin",
      component: () => import("./pages/Requests/RequestsListAdmin")
    },

    {
      path: "/request/uploadRequests",
      alias: "/uploadRequests",
      beforeEnter: guardMyroute,
      name: "uploadRequests",
      component: () => import("./pages/Requests/UploadRequests")
    },

    {
      path: "/request/uploadRequestsAdmin",
      alias: "/uploadRequestsAdmin",
      beforeEnter: guardMyroute,
      name: "uploadRequestsAdmin",
      component: () => import("./pages/Requests/UploadRequestsAdmin")
    },

    {
      path: "/request/requests/:id",
      beforeEnter: guardMyroute,
      name: "request-details",
      component: () => import("./pages/Requests/Request")
    },

    {
      path: "/request/requestsAdmin/:id",
      beforeEnter: guardMyroute,
      name: "request-details",
      component: () => import("./pages/Requests/RequestAdmin")
    },

    {
      path: "/request/addRequest",
      beforeEnter: guardMyroute,
      name: "addRequest",
      component: () => import("./pages/Requests/AddRequest")
    },

    {
      path: "/request/addRequestAdmin",
      beforeEnter: guardMyroute,
      name: "addRequestAdmin",
      component: () => import("./pages/Requests/AddRequestAdmin")
    },

    {
      path: "/matching/matchingAdmin",
      beforeEnter: guardMyroute,
      alias: "/matchingAdmin",
      name: "matchingAdmin",
      component: () => import("./pages/Matching/MatchingAdmin")
    },
    {
      path: "/matching/matchingAdminBG",
      beforeEnter: guardMyroute,
      alias: "/matchingAdminBG",
      name: "matchingAdminBG",
      component: () => import("./pages/Matching/MatchingDSOTRAuto")
    },

    {
      path: "/matching/matchingAdminTR",
      beforeEnter: guardMyroute,
      alias: "/matchingAdminTR",
      name: "matchingAdminTR",
      component: () => import("./pages/Matching/MatchingDSOTRAuto")
    },

    {
      path: "/matching/matchingTSO",
      beforeEnter: guardMyroute,
      alias: "/matchingTSO",
      name: "matchingTSO",
      component: () => import("./pages/Matching/MatchingTSO")
    },
    {
      path: "/matching/matchingTsoBG",
      beforeEnter: guardMyroute,
      alias: "/matchingTsoBG",
      name: "matchingTsoBG",
      component: () => import("./pages/Matching/MatchingTsoBG")
    },
    {
      path: "/matching/matchingTsoTR",
      beforeEnter: guardMyroute,
      alias: "/matchingTsoTR",
      name: "matchingTsoTR",
      component: () => import("./pages/Matching/MatchingTsoTR")
    },

    {
      path: "/matching/matchingDSO",
      beforeEnter: guardMyroute,
      alias: "/matchingDSO",
      name: "matchingDSO",
      component: () => import("./pages/Matching/MatchingDSO")
    },
    {
      path: "/matching/matchingDsoBG",
      beforeEnter: guardMyroute,
      alias: "/matchingDsoBG",
      name: "matchingDsoBG",
      component: () => import("./pages/Matching/MatchingDSOTRAuto")
    },
    {
      path: "/matching/matchingDsoSI",
      beforeEnter: guardMyroute,
      alias: "/matchingDsoSI",
      name: "matchingDsoSI",
      component: () => import("./pages/Matching/MatchingDsoTR")
    },
    {
      path: "/matching/matchingDsoTR",
      beforeEnter: guardMyroute,
      alias: "/matchingDsoTR",
      name: "matchingDsoTR",
      component: () => import("./pages/Matching/MatchingDSOTRAuto")
    },
    {
      path: "/matching/matchingDsoTRAuto",
      beforeEnter: guardMyroute,
      alias: "/matchingDsoTRAuto",
      name: "matchingDsoTRAuto",
      component: () => import("./pages/Matching/MatchingDSOTRAuto")
    },

    {
      path: "/matching/matchingFSP",
      beforeEnter: guardMyroute,
      alias: "/matchingFSP",
      name: "matchingFSP",
      component: () => import("./pages/Matching/MatchingFSP")
    },
    {
      path: "/matching/matchingFspBG",
      beforeEnter: guardMyroute,
      alias: "/matchingFspBG",
      name: "matchingFspBG",
      component: () => import("./pages/Matching/MatchingFspBG")
    },
    {
      path: "/matching/matchingFspTR",
      beforeEnter: guardMyroute,
      alias: "/matchingFspTR",
      name: "matchingFspTR",
      component: () => import("./pages/Matching/MatchingFspTR")
    },
    
    {
      path: "/tutorialAdmin",
      beforeEnter: guardTutorial,
      name: "tutorialAdmin",
      component: () => import("./pages/TutorialAdmin")
    },
    {
      path: "/tutorialTSO",
      beforeEnter: guardTutorial,
      name: "tutorialTSO",
      component: () => import("./pages/TutorialTSO")
    },
    {
      path: "/tutorialDSO",
      beforeEnter: guardTutorial,
      name: "tutorialDSO",
      component: () => import("./pages/TutorialDSO")
    },
    {
      path: "/tutorialFSP",
      beforeEnter: guardTutorial,
      name: "tutorialFSP",
      component: () => import("./pages/TutorialFSP")
    },

    {
      path: "/supportAdmin",
      beforeEnter: guardMyroute,
      name: "supportAdmin",
      component: () => import("./pages/SupportAdmin")
    },
    {
      path: "/supportTSO",
      beforeEnter: guardMyroute,
      name: "supportTSO",
      component: () => import("./pages/SupportTSO")
    },
    {
      path: "/supportDSO",
      beforeEnter: guardMyroute,
      name: "supportDSO",
      component: () => import("./pages/SupportDSO")
    },
    {
      path: "/supportFSP",
      beforeEnter: guardMyroute,
      name: "supportFSP",
      component: () => import("./pages/SupportFSP")
    },

    {
      path: "/pricingintelligenceAdmin",
      beforeEnter: guardMyroute,
      name: "pricingIntelligenceAdmin",
      component: () => import("./pages/PricingIntelligenceAdmin")
    },
    {
      path: "/pricingintelligenceTSO",
      beforeEnter: guardMyroute,
      name: "pricingIntelligenceTSO",
      component: () => import("./pages/PricingIntelligenceTSO")
    },
    {
      path: "/pricingintelligenceDSO",
      beforeEnter: guardMyroute,
      name: "pricingIntelligenceDSO",
      component: () => import("./pages/PricingIntelligenceDSO")
    },
    {
      path: "/pricingintelligenceFSP",
      beforeEnter: guardMyroute,
      name: "pricingIntelligenceFSP",
      component: () => import("./pages/PricingIntelligenceFSP")
    },
    {
      path: "/forecasting",
      beforeEnter: guardMyroute,
      name: "forecasting",
      component: () => import("./pages/Forecasting")
    },

    {
      path: "/admin",
      beforeEnter: guardAdmin,
      name: "admin",
      component: () => import("./views/Admin")
    },

  ]
});
